import React,{useEffect,useState} from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle,Spinner } from "reactstrap";
import DataLoader from "../../../components/tableData";
import {httpGet} from "../../../common/petitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import PositionsModel from './model.json'
import { useNavigate } from 'react-router-dom'
import "../tables.scss";
import "../Puestos.scss";


const reporte_semanal = () => {
  const [data, setData] = useState(null);
  const [puestos, setPuestos] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Fetch the JSON data from the server
    const fetchData = async () => {
      try {
        const rowsData = await httpGet('/mod/desgloce',navigate)
        // console.log(PositionsModel.zafra_normal);
        setPuestos(rowsData)
        const {columns,rows} = addLabelsToTotalGlobal(rowsData,PositionsModel.zafra_normal)
        const jsonData = { "columns": columns, "rows": rows };
        setData(jsonData);
        console.log(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []); 
  
  const toggleActiveButton = (event, reporte) => {
    event.preventDefault();
    removeOutlineClasses();
    event.target.classList.add(`selected`);
    // console.log(PositionsModel[reporte]);
    const {columns,rows} = addLabelsToTotalGlobal(puestos,PositionsModel[reporte])
    const jsonData = { "columns": columns, "rows": rows };
    // console.log(jsonData);
        setData(jsonData);
  };

  const addLabelsToTotalGlobal = (data, columnsOrigin) => {
    const totalGlobalEntry = data.find(entry => entry.ccu === "TOTAL GLOBAL");
    const rows = data.filter(entry => entry.ccu !== "TOTAL GLOBAL");

    // Create a new array for modified columns
    const columns = columnsOrigin.map(column => {
        // Create a copy of the original column object
        const newColumn = Object.assign({}, column);

        // Check if the totalGlobalEntry exists and the value for the column is not undefined or "TOTAL GLOBAL"
        if (totalGlobalEntry && totalGlobalEntry[newColumn.field] !== undefined && totalGlobalEntry[newColumn.field] !== "TOTAL GLOBAL") {
            // Append the value to the label
            newColumn.label = `${newColumn.label} ${totalGlobalEntry[newColumn.field]}`;
        }
        return newColumn;
    });

    return { columns, rows };
  };



  // const totalsHeaders = (columns,rows) =>{
  //   const column = columns
  //   columns.forEach(){

  //   }
  //   console.log(rows['TOTAL GLOBAL']);
  //   delete(rows['TOTAL GLOBAL'])
  //   return {columns, rows}
  // }
  const removeOutlineClasses = () => {
    const buttons = document.querySelectorAll('.selected');
    buttons.forEach(button => {
      button.classList.remove("selected");
    });
  };
  const options = {
    bordered:true
  }
  document.title = "Mano de obra Directa - Ingreso puestos - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Mano de obra directa" title="Reportes por tipo de semana"  />

          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                  <button
                    className={'me-3 btn btn btn-primary'}
                    onClick={(event) => toggleActiveButton(event,"zafra_normal")}
                  >
                    <i className="bx bx-download me-1"></i>Zafra - Semana normal
                    </button>
                  <button
                    // color="primary"
                    className={'me-3 btn btn btn-primary'}
                    onClick={(event) => toggleActiveButton(event,"zafra_asueto")}
                  >
                    <i className="bx bx-download me-1"></i>Zafra - Semana Asueto
                  </button>
                  <button
                    // color="primary"
                    className={'me-3 btn btn btn-primary'}
                    onClick={(event) => toggleActiveButton(event,"zafra_semanas")}
                  >
                    <i className="bx bx-download me-1"></i>Zafra - Semana Semana Santa
                  </button>
                  <button
                    // color="warning"
                    className={'me-3 btn btn btn-warning'}
                    onClick={(event) => toggleActiveButton(event,"repara_normal")}
                  >
                    <i className="bx bx-download me-1"></i>Reparacion - Semana normal
                  </button>
                  <button
                  className={'me-3 btn btn btn-warning'}
                    onClick={(event) => toggleActiveButton(event,"repara_asueto")}
                  >
                    <i className="bx bx-download me-1"></i>Reparacion - Semana Asueto
                  </button>
                  {<DataLoader isLoading={isLoading} data={data}  />}
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default reporte_semanal;
